import * as req from 'api/actions';
import alert from 'react-s-alert';
import * as c from './constant';

export const getRequirementList = (payload, callback) =>
  req.list(
    c.GET_REQUIREMENT,
    '/api/v1/administrators/how_tos_menu',
    payload,
    callback
  );

export const showRequirement = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_REQUIREMENT,
    `/api/v1/administrators/how_tos_menu/${id}`,
    payload,
    callback
  );

export const createRequirement = (payload, callback) =>
  req.create(
    c.CREATE_REQUIREMENT,
    '/api/v1/administrators/how_tos_menu',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateRequirement = (id, payload, callback) =>
  req.update(
    c.UPDATE_REQUIREMENT,
    `/api/v1/administrators/how_tos_menu/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeRequirement = (id, payload, callback) =>
  req.remove(
    c.REMOVE_REQUIREMENT,
    `/api/v1/administrators/how_tos_menu/${id}`,
    payload,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Remove !');
      if (callback) callback();
    }
  );
